import React from 'react';
import { Shield, Zap, Globe, Lock } from 'lucide-react';

const SettingStandards = () => {
  const standards = [
    {
      icon: Shield,
      title: 'Stellar Security',
      description: 'Enterprise-grade security inherited from Stellar\'s battle-tested consensus protocol'
    },
    {
      icon: Zap,
      title: 'XRPL Speed',
      description: 'Leverage XRP Ledger\'s 3-5 second finality for instant trade execution'
    },
    {
      icon: Globe,
      title: 'Borderless Trading',
      description: 'Access U.S. markets from 150+ countries without traditional brokerage barriers'
    },
    {
      icon: Lock,
      title: 'Non-Custodial',
      description: 'Your keys, your stocks. True ownership with self-custody wallet support'
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#0b0014] to-[#10051f] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-purple-500/50 to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-purple-500/30 to-transparent" />
      </div>
      
      <div className="max-w-[1200px] mx-auto px-6 relative">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
              Setting new
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-400">
                standards.
              </span>
            </h2>
            <p className="text-base md:text-xl text-gray-400 leading-relaxed">
              The first Layer 1 blockchain purpose-built for tokenized equities. Combining Stellar's security with XRPL's liquidity.
            </p>
          </div>
          
          {/* Right - Standards Grid */}
          <div className="grid grid-cols-2 gap-4">
            {standards.map((item, index) => {
              const Icon = item.icon;
              return (
                <div 
                  key={index}
                  className="p-6 bg-white/[0.02] border border-white/[0.06] rounded-2xl hover:border-purple-500/30 hover:bg-white/[0.04] transition-all duration-300 group"
                >
                  <div className="w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center mb-4 group-hover:bg-purple-500/20 transition-colors">
                    <Icon className="w-6 h-6 text-purple-400" />
                  </div>
                  <h3 className="text-white font-semibold mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SettingStandards;
